"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Content = void 0;
const react_1 = __importDefault(require("react"));
const elements_ui_utils_1 = require("@hydrogen/elements.ui.utils");
const themes_1 = require("../themes");
const Content = ({ children, breadcrumbs }) => (react_1.default.createElement("main", { className: (0, elements_ui_utils_1.classNames)(themes_1.theme.main.box, themes_1.theme.main.colors, themes_1.theme.main.font) },
    react_1.default.createElement("div", { className: "mx-auto px-4 sm:px-6 md:px-16 max-w-page" },
        breadcrumbs,
        children)));
exports.Content = Content;
//# sourceMappingURL=Content.js.map